import { ILogin } from '../../../TYPES/api.body';
import { ADMIN_LOGIN } from '../../config/endpoints';
// import { ADMIN_LOGIN, LOGIN } from "../../config/endpoints";
import axios from 'axios';

export const adminLogin = async (formData: ILogin) => {
  // Create a clean axios instance without auth headers
  const cleanApi = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
  });

  return await cleanApi.post(ADMIN_LOGIN, formData);
};
